import { useTranslate } from '@tolgee/react';
import { useState } from 'react';
import BonusIcon from '../../../assets/icons/bons1.jpg';
import ArrowIcon from '../../../assets/icons/Chevron Rigth.svg';
import BackgroundImage from '../../../assets/images/Voucher-image.png';
import { PERMISSION_CODES } from '../../../constants/permissionCodes';
import Can from '../../common/Can';
import VoucherCheckout from '../voucher-checkout/VoucherCheckout';
import './VoucherSection.scss';

const VoucherSection = () => {
  const { t } = useTranslate();
  const [checkoutSectionVisible, toggleCheckoutSectionVisibility] =
    useState(false);

  return (
    <>
      {checkoutSectionVisible ? (
        <VoucherCheckout
          toggleCheckoutSectionVisibility={toggleCheckoutSectionVisibility}
        />
      ) : (
        <div className='voucher-main-section-container'>
          <img className='voucher-section-img' src={BackgroundImage} />
          <div className='voucher-section-detail gradient-background'>
            <div className='voucher-section-detail-inner'>
              <h2 className='voucher-section-primary__text'>
                {t('voucher-section-heading-1')}
              </h2>

              <div className='voucher-section-tertiary__container'>
                <h1 className='voucher-section-tertiary__text'>
                  {t('voucher-section-heading-3')}
                </h1>
              </div>
              <Can
                permission={PERMISSION_CODES.VOUCHER_REQUESTS_CREATE}
                mode='disable'
              >
                <div
                  className='voucher-main-section-header-container1'
                  onClick={() => toggleCheckoutSectionVisibility(true)}
                >
                  <img src={BonusIcon} alt='' />
                  <p>{t('order your vouchers here')}</p>
                  <img src={ArrowIcon} alt='' style={{ width: '15px' }} />
                </div>
              </Can>
            </div>
          </div>
          <div className='voucher-section-how-it-works'>
            <div className='voucher-section-how-it-works-inner'>
              <h2>
                {t('voucher.howItWorks.title')}{' '}
                {t('voucher.howItWorks.subtitle')}
              </h2>
              <ul>
                <li>
                  <span className='count'>1</span>
                  {t('voucher.howItWorks.steps.1')}
                </li>
                <li>
                  <span className='count'>2</span>
                  {t('voucher.howItWorks.steps.2')}
                </li>
                <li>
                  <span className='count'>3</span>
                  {t('voucher.howItWorks.steps.3')}
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default VoucherSection;
